import styled from "styled-components";

export const FestivalCompetitionEventsWrapper = styled.div`
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FestivalCompetitionEventTapWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const FestivalCompetitionEventTap = styled.div<{ isSelect: boolean }>`
  padding: 9px 16px;
  height: 30px;
  border-radius: 15px;
  background: ${({ isSelect }) => (isSelect === true ? "#6436E7" : "#fff")};
  color: ${({ isSelect }) => (isSelect === true ? "#fff" : "#B7B7B7")};
  border: ${({ isSelect }) =>
    isSelect === true ? "none" : "1px solid #B7B7B7"};
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const FestivalCompetitionEventsDateList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  > .title {
    font-weight: 700;
    font-size: 20px;
  }
`;

export const FestivalCompetitionEventsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FestivalCompetitionEventsItem = styled.div<{ url?: string }>`
  background-image: url("${(p) => p.url}");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 230px;
  border-radius: 8px;
  position: relative;
  padding: 20px 12px;
  color: #fff;

  > .back {
    border-radius: 8px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(240.47deg, rgba(0, 0, 0, 0) 5%, #000000 73.21%),
      linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
  }
`;

export const FestivalCompetitionEventsItemTop = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;

  > .time {
    background: #ffd101b0;
    height: 25px;
    max-width: 89px;
    text-align: center;
    border-radius: 12px;
    font-weight: 700;
    font-size: 10px;
    line-height: 25px;
  }

  > .title {
    font-weight: 700;
    font-size: 18px;
  }
`;

export const FestivalCompetitionEventsItemInfo = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  margin-top: 25px;

  > .bar {
    border-right: 1px solid #ffffff;
    width: 1px;
    height: 25px;
  }
`;

export const FestivalCompetitionEventsItemInfoBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;

  > .name {
    font-weight: 300;
    font-size: 10px;
    text-align: center;
  }

  > .value {
    font-weight: 700;
    font-size: 14px;
    text-align: center;
  }
`;

export const FestivalCompetitionEventsItemButton = styled.div<{
  isReservation: boolean;
}>`
  position: relative;
  background: ${(p) =>
    p.isReservation ? "var(--Purple-300, #6436e7)" : "#1F9F81"};
  width: 100%;
  height: 48px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  text-align: center;
  line-height: 48px;
  margin-top: 12px;
`;
